import React, {PureComponent} from 'react'
import cn from 'classnames'
import injectSheet from 'react-jss'
import CentredContentContainer from "../Widgets/CentredContentContainer"
import RichTextContainer from "../Widgets/RichTextContainer"
import Link from "../Widgets/Link"

class RichTextItem extends PureComponent {

    render() {
        const {classes, centered, item: {text, ga_tracking, button_link, button_position, apply_drop_cap}} = this.props;
        const hasCTALink = button_link && button_link.url;

        return (
            <section className={hasCTALink && classes.ctaWrapper}>
                <CentredContentContainer >
                    <RichTextContainer content={text} ga_tracking={ga_tracking} removeBottomMargin={!hasCTALink} className={cn({[classes.centered]: centered})} applyDropCap={apply_drop_cap}/>
                    {hasCTALink && <div className={cn(classes.link, centered ? classes.centered_link : (button_position && button_position.toLowerCase()))}><Link link={button_link} size="small">{button_link.label}</Link></div>}
                </CentredContentContainer>
            </section>
        )
    }
}

export default injectSheet(theme=>({
    link: {
        '&.right': {
            textAlign: 'right'
        },
        '&.center': {
            textAlign: 'center'
        }
    },
    ctaWrapper: {
        marginBottom: '1.6rem'
    },
    centered: {
        textAlign: 'center',
    },
    centered_link: {
        textAlign: 'center',
        "& a": {
            marginLeft: 0,
        }
    }
}))(RichTextItem)



// WEBPACK FOOTER //
// ./src/components/Article/RichTextItem.js